import { ResourceData, ResourceTypes } from './types';

export const calcProgress = (clock: number, baseTimeMs: number) => ((clock % baseTimeMs) / baseTimeMs) * 100;
export const getProgress = (type: ResourceTypes, oldClock: number, newClock: number) => {
  const { baseTimeMs = 0 } = ResourceData[type];
  return [calcProgress(oldClock, baseTimeMs), calcProgress(newClock, baseTimeMs)];
};
